import { ProgressBar } from '@progress/kendo-react-progressbars';
import React from 'react';
import './BaseProgressBar.less';
import clsx from 'clsx';

interface Props {
  className?: string;
  value: number;
}

export default function BaseProgressBar({ className, value }: Props) {
  return (
    <ProgressBar
      value={value}
      className={clsx('base-progress-bar', className)}
    />
  );
}
